
<div class="text-alert">
  <i class="fas fa-exclamation-triangle"></i>
  No tienes acceso a esta información.
</div>
